import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./home-skeleton.css";

const HomeSkeleton = () => {
  const skeletonVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0.5 },
    visible: { opacity: 1 },
  };

  return (
    <motion.section
      className="home section"
      id="home"
      initial="hidden"
      animate="visible"
      variants={skeletonVariants}
    >
      <div className="home__container container grid">
        <div className="home__content grid">
          {/* Skeleton Social Links */}
          <div className="home__social skeleton-social">
            <motion.div variants={itemVariants} className="skeleton-icon" />
            <motion.div variants={itemVariants} className="skeleton-icon" />
            <motion.div variants={itemVariants} className="skeleton-icon" />
            <motion.div variants={itemVariants} className="skeleton-icon" />
          </div>

          {/* Skeleton Image */}
          <motion.div
            variants={itemVariants}
            className="home__img skeleton-image"
          />

          {/* Skeleton Data */}
          <div className="home__data skeleton-data">
            <motion.div variants={itemVariants} className="skeleton-title" />
            <motion.div variants={itemVariants} className="skeleton-subtitle" />
            <div className="skeleton-description-container">
              <motion.div variants={itemVariants} className="skeleton-line" />
              <motion.div
                variants={itemVariants}
                className="skeleton-line short"
              />
            </div>
            <motion.div variants={itemVariants} className="skeleton-button" />
          </div>
        </div>

        {/* Skeleton Scroll Down */}
        <motion.div variants={itemVariants} className="skeleton-scroll" />
      </div>
    </motion.section>
  );
};

export default HomeSkeleton;
